import { DocumentItem } from 'features/Documents'
import { FC, useState } from 'react'
import { Loader } from 'view/Loader'

import { DocumentInformation } from './manualQuoteDocumentsApi'

const allowedFormats = ['.pdf', '.jpg', '.jpeg', '.png', '.ttf', '.webp', '.csv', '.xls', '.xlsx']

type BookingDocumentsListProps = {
  documents: DocumentInformation[]
  onDelete: (documentKey: string) => void
  onReplace: (file: File, documentInformation: DocumentInformation) => void
  isLoading: boolean
  fetchPreviewUrl: (documentInformation: DocumentInformation) => Promise<string>
}

export const ManualQuoteDocumentsList: FC<BookingDocumentsListProps> = ({
  documents,
  onDelete,
  onReplace,
  isLoading,
  fetchPreviewUrl,
}) => {
  const [previewUrl, setPreviewUrl] = useState('')

  const handleOnPreview = async (doc: DocumentInformation) => {
    const url = await fetchPreviewUrl(doc)
    setPreviewUrl(url)
  }
  if (isLoading) {
    return <Loader show />
  }

  return (
    <>
      {documents.map((doc) => (
        <DocumentItem
          showDownloadButton={false}
          key={doc._id}
          doc={doc}
          inputName="file-upload"
          onPreview={() => handleOnPreview(doc)}
          onPreviewClose={() => setPreviewUrl('')}
          url={previewUrl}
          uploadFile={(file) => onReplace(file, doc)}
          deleteFile={() => onDelete(doc._id)}
          allowedFormats={allowedFormats}
        />
      ))}
    </>
  )
}
